import React from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Services = () => {
  const services = [
    {
      id: 0,
      name: "Mobile App Development",
      iconName: "fa-solid fa-mobile-screen-button",
      description:
        "Native iOS and Android apps, built with Swift, Java, or React Native and shipped to both app stores.",
    },
    {
      id: 1,
      name: "Web Development",
      iconName: "fa-solid fa-laptop",
      description:
        "Responsive websites and full web applications — frontend, backend, APIs, and databases.",
    },
    {
      id: 2,
      name: "Web Hosting & Maintenance",
      iconName: "fa-regular fa-hard-drive",
      description:
        "Secure hosting, monitoring, updates, and ongoing support so your software stays fast and reliable.",
    },
  ];

  const stacks = [
    {
      id: 0,
      title: "Frontend",
      items: ["React", "React Native", "Redux", "ES6+", "Swift", "Objective-C", "Java"],
    },
    {
      id: 1,
      title: "Backend",
      items: ["Node.js", "PHP", "Java", "Python / Flask", "REST APIs", "Firebase"],
    },
    {
      id: 2,
      title: "Data & Infrastructure",
      items: ["MySQL / MariaDB", "MongoDB", "Web Hosting", "Deployment & CI"],
    },
  ];

  return (
    <Container fluid style={styles.container}>
      <Container>
        <Row className="text-center mb-5">
          <h1 style={styles.pageTitle}>Services</h1>
          <p style={styles.pageSubtitle}>
            We work with our clients to create affordable, world-class
            software.
          </p>
        </Row>

        <Row style={{ marginBottom: 90 }}>
          {services.map((item) => (
            <Col key={item.id} xs={12} md={4} className="mb-4 mb-md-0">
              <Card style={styles.card} className="h-100">
                <Card.Body className="text-center">
                  <FontAwesomeIcon
                    icon={item.iconName}
                    size="3x"
                    style={styles.icon}
                  />
                  <Card.Title style={styles.cardTitle}>{item.name}</Card.Title>
                  <Card.Text style={styles.cardText}>
                    {item.description}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        <Row className="text-center mb-4">
          <h2 style={styles.sectionTitle}>Technologies we work with</h2>
        </Row>
        <Row style={{ marginBottom: 90 }}>
          {stacks.map((stack) => (
            <Col key={stack.id} xs={12} md={4} className="mb-4 mb-md-0">
              <div style={styles.stackCard}>
                <h3 style={styles.stackTitle}>{stack.title}</h3>
                <ul style={styles.stackList}>
                  {stack.items.map((tech) => (
                    <li key={tech} style={styles.stackItem}>
                      {tech}
                    </li>
                  ))}
                </ul>
              </div>
            </Col>
          ))}
        </Row>

        <Row className="text-center">
          <Col>
            <h3 style={styles.ctaTitle}>Not sure what you need?</h3>
            <p style={styles.ctaText}>
              Tell us about your project and we&apos;ll recommend the right
              approach.
            </p>
            <Button variant="primary" size="lg" as={Link} to="/contact">
              Start the conversation
            </Button>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Services;

const styles = {
  card: {
    backgroundColor: "#1C1816",
    color: "#FFF",
    border: "1px solid #2E2925",
    borderRadius: 12,
    padding: 16,
  },
  cardText: {
    color: "#ACACAC",
    fontSize: 16,
    lineHeight: 1.6,
  },
  cardTitle: {
    fontSize: 22,
    fontWeight: 600,
    marginBottom: 12,
  },
  container: {
    backgroundColor: "#000",
    paddingTop: 100,
    paddingBottom: 100,
  },
  ctaText: {
    color: "#ACACAC",
    fontSize: 18,
    marginBottom: 24,
  },
  ctaTitle: {
    color: "#FFF",
    fontSize: 30,
    fontWeight: 700,
    marginBottom: 8,
  },
  icon: {
    color: "#CF3620",
    marginBottom: 20,
  },
  pageSubtitle: {
    color: "#ACACAC",
    fontSize: 20,
  },
  pageTitle: {
    color: "#FFF",
    fontSize: 44,
    fontWeight: 800,
    marginBottom: 12,
  },
  sectionTitle: {
    color: "#FFF",
    fontSize: 32,
    fontWeight: 700,
  },
  stackCard: {
    backgroundColor: "#1C1816",
    border: "1px solid #2E2925",
    borderRadius: 12,
    padding: 24,
    height: "100%",
    textAlign: "left",
  },
  stackItem: {
    color: "#FFF",
    fontSize: 17,
    marginBottom: 8,
  },
  stackList: {
    paddingLeft: 20,
    marginBottom: 0,
  },
  stackTitle: {
    color: "#CF3620",
    fontSize: 18,
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: 1,
    marginBottom: 16,
  },
};
